import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Typography, Stack } from "@mui/material";
import HeightBox from "../HeightBox";
import { getAge } from "../../util/calculations.utils";
import { Box } from "@mui/system";
import fontStyles from "./_fontStyles";

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2pt",
  fontWeight: 600,
  lineHeight: 1.8,
  textTransform: "uppercase",
  ...fontStyles,
  color: "#2AA0B5",
}));

export const CustomerApplicationPrintOut = React.forwardRef((props, ref) => {
  const { formValues, displayImages } = props;
  const reg_number = formValues.reg_number;
  const full_name = formValues.full_name;
  const dob = formValues.dob;
  const license = formValues.license;
  const nic = formValues.nic;
  const nationality = formValues.nationality;
  const region = formValues.region;
  const placeOfBirth = formValues.placeOfBirth;
  const town = formValues.town;
  const passport = formValues.passport;
  const passport_issued = formValues.passport_issued;
  const address = formValues.address;
  const des_country = formValues.des_country;
  const height = formValues.height;
  const weight = formValues.weight;
  const complexion = formValues.complexion;
  const education = formValues.education;
  const marital_Status = formValues.marital_Status;
  const noOfChildren = formValues.noOfChildren;
  const guardian_name = formValues.guardian_name;
  const guardian_number = formValues.guardian_number;
  const passport_place = formValues.passport_place;
  const passport_expired = formValues.passport_expired;
  const phone_mobile = formValues.phone_mobile;
  const phone_home = formValues.phone_home;
  const phone_other = formValues.phone_other;
  const experienceOneCountry = formValues.experienceOneCountry;
  const experienceOneServicePeriodStart = formValues.experienceOneServicePeriodStart;
  const experienceOneServicePeriodEnd = formValues.experienceOneServicePeriodEnd;
  const experienceOneJob = formValues.experienceOneJob;
  const experienceTwoCountry = formValues.experienceTwoCountry;
  const experienceTwoServicePeriodStart = formValues.experienceTwoServicePeriodStart;
  const experienceTwoServicePeriodEnd = formValues.experienceThreeServicePeriodEnd;
  const experienceTwoJob = formValues.experienceTwoJob;
  const experienceThreeCountry = formValues.experienceThreeCountry;
  const experienceThreeServicePeriodStart = formValues.experienceThreeServicePeriodStart;
  const experienceThreeServicePeriodEnd = formValues.experienceTwoServicePeriodEnd;
  const experienceThreeJob = formValues.experienceThreeJob;
  const english = formValues.english;
  const hindi = formValues.hindi;
  const tamil = formValues.tamil;
  const arabic = formValues.arabic;
  const otherLang = formValues.otherLang;
  const otherLangFl = formValues.otherLangFl;
  const post_applied_for = formValues.post_applied_for;
  const contract_start = formValues.contract_start;
  const contract_end = formValues.contract_end;
  const salary = formValues.salary;
  const passport_size_image = displayImages.passportSize;
  const full_size_image = displayImages.fullSize;
  const driving = formValues.driving;
  const cleaning = formValues.cleaning;
  const sewing = formValues.sewing;
  const cooking = formValues.cooking;
  const baby_sitting = formValues.baby_sitting;
  const washing = formValues.washing;
  const prev_country = formValues.prev_country;
  const prev_contract_start = formValues.prev_contract_start;
  const prev_contract_end = formValues.prev_contract_end;
  const gender = formValues.gender;

  return (
    <Container elevation={0} ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      <img
        src="/images/application_form.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      />
      {/* 192.168.1.71:3000 */}
      {passport_size_image && (
        <Box
          component="img"
          sx={{
            position: "absolute",
            height: "3.8cm",
            width: "3.6cm",
            top: 240,
            left: 45,
          }}
          alt="The house from the offer."
          src={passport_size_image}
        />
      )}
      {full_size_image && (
        <Box
          component="img"
          sx={{
            width: 350,
            position: "absolute",
            height: "10.4cm",
            width: "9.1cm",
            bottom: 82,
            right: 48,
          }}
          alt="The house from the offer."
          src={full_size_image}
        />
      )}
      <HeightBox height={245} />
      <CustomTypography style={{ marginLeft: 630 }}>
        <span>{reg_number ? reg_number : "-"}</span>
        <br></br>
        {gender === 1 ? "Male" : "Female"}
      </CustomTypography>
      <HeightBox height={15} />
      <CustomTypography style={{ marginLeft: 290 }}>{post_applied_for ? post_applied_for : "-"}</CustomTypography>
      <HeightBox height={2} />
      <CustomTypography style={{ marginLeft: 290 }}>{salary ? salary : "-"}</CustomTypography>
      <HeightBox height={1} />
      <CustomTypography style={{ marginLeft: 290, marginTop: "-4pt" }}>
        {contract_start ? contract_start : "-"} - {contract_end ? contract_end : "-"}
      </CustomTypography>
      <HeightBox height={4} />
      <CustomTypography style={{ marginLeft: 220 }}>{full_name ? full_name : "-"}</CustomTypography>
      <HeightBox height={24} />
      <Stack direction="row">
        <Stack direction="column">
          <CustomTypography style={{ marginLeft: 150 }}>{nationality ? nationality : "-"}</CustomTypography>
          {/* <HeightBox height={1} /> */}
          <CustomTypography style={{ marginLeft: 150 }}>{region ? region : "-"}</CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 150, marginTop: "-4pt" }}>{dob ? dob : "-"}</CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 150, marginTop: "-2pt" }}>
            {placeOfBirth ? placeOfBirth : "-"}
          </CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 150, marginTop: "-2pt" }}>{town ? town : "-"}</CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 150, marginTop: "-6pt" }}>
            {marital_Status ? "Married" : "Un married"}
          </CustomTypography>
          <HeightBox height={5} />
          <CustomTypography style={{ marginLeft: 150, marginTop: "-8pt" }}>
            {noOfChildren ? noOfChildren : "-"}
          </CustomTypography>
          <HeightBox height={-2} />
          <CustomTypography style={{ marginLeft: 150, marginTop: -2 }}>{weight ? weight : "-"}</CustomTypography>

          <CustomTypography style={{ marginLeft: 150, marginTop: "-3pt" }}>{height ? height : "-"}</CustomTypography>

          <CustomTypography style={{ marginLeft: 150, marginTop: "-3pt" }}>
            {complexion ? complexion : "-"}
          </CustomTypography>

          <CustomTypography style={{ marginLeft: 188, marginTop: "-2pt" }}>
            {education ? education : "-"}
          </CustomTypography>
          <HeightBox height={55} />
          <Stack direction="row">
            <Stack direction="column">
              <CustomTypography style={{ marginLeft: 170, marginTop: "-3pt" }}>
                {english === "0" ? <span>&#10003;</span> : "-"}
              </CustomTypography>

              <CustomTypography style={{ marginLeft: 170, marginTop: "-3pt" }}>
                {english === "1" ? <span>&#10003;</span> : "-"}
              </CustomTypography>

              <CustomTypography style={{ marginLeft: 170, marginTop: "-3pt" }}>
                {english === "2" ? <span>&#10003;</span> : "-"}
              </CustomTypography>
            </Stack>
            <Stack direction="column">
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 80, marginTop: "-2pt" }}>
                {arabic === 0 ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 80, marginTop: "-2pt" }}>
                {arabic === 1 ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 80, marginTop: "-2pt" }}>
                {arabic === 2 ? <span>&#10003;</span> : "-"}
              </CustomTypography>
            </Stack>
          </Stack>
          <HeightBox height={12} />
          <Stack direction="column">
            <HeightBox height={1} />
            <CustomTypography style={{ marginLeft: 120, marginTop: "3pt" }}>
              {prev_country ? prev_country : "-"}
            </CustomTypography>
            <HeightBox height={0} />
            <CustomTypography style={{ marginLeft: 120, marginTop: "-4pt", paddingTop: "2pt" }}>
              {prev_contract_start ? prev_contract_start : "-"} - {prev_contract_end ? prev_contract_end : "-"}{" "}
            </CustomTypography>
          </Stack>
          <HeightBox height={23} />
          <Stack direction="row">
            <Stack direction="column">
              <HeightBox height={0} />
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 140, marginTop: "2pt" }}>
                {driving ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 140, marginTop: "-8pt" }}>
                {sewing ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 140, marginTop: "-8pt" }}>
                {baby_sitting ? <span>&#10003;</span> : "-"}
              </CustomTypography>
            </Stack>
            <Stack direction="column">
              <HeightBox height={0} />
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 150, marginTop: "2pt" }}>
                {cleaning ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 150, marginTop: "-8pt" }}>
                {cooking ? <span>&#10003;</span> : "-"}
              </CustomTypography>
              <HeightBox height={1} />
              <CustomTypography style={{ marginLeft: 150, marginTop: "-8pt" }}>
                {washing ? <span>&#10003;</span> : "-"}
              </CustomTypography>
            </Stack>
          </Stack>
        </Stack>
        <Stack direction="column">
          <HeightBox height={4} />
          <CustomTypography style={{ marginLeft: 200 }}>{passport ? passport : "-"}</CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 200 }}>{passport_issued ? passport_issued : "-"}</CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 200, marginTop: "-1pt" }}>
            {passport_place ? passport_place : "-"}
          </CustomTypography>
          <HeightBox height={1} />
          <CustomTypography style={{ marginLeft: 200, marginTop: "-4pt" }}>
            {passport_expired ? passport_expired : "-"}
          </CustomTypography>
          <HeightBox height={1} />
        </Stack>
      </Stack>
      {/* <span style={{ marginLeft: 200, marginTop: 1000 }}>{reg_number ? reg_number : "-"}</span> */}
      {/* <HeightBox height={9} />
      <CustomTypography style={{ marginLeft: 250 }}>{lieceneNumber}</CustomTypography>
      <HeightBox height={1} />
      <CustomTypography style={{ marginLeft: 250 }}>{nationalId}</CustomTypography>
      <HeightBox height={8} />
      <Stack direction="row">
        <CustomTypography style={{ marginLeft: 250 }}>{birthday}</CustomTypography>
        <CustomTypography style={{ marginLeft: 100 }}>{age}</CustomTypography>
      </Stack>
      <HeightBox height={3} />
      <CustomTypography style={{ marginLeft: 250 }}>{height}</CustomTypography>
      <HeightBox height={5} />
      <CustomTypography style={{ marginLeft: 265 }}>{marriedChildren}</CustomTypography>
      <HeightBox height={4} />
      <Stack direction="row">
        <CustomTypography style={{ marginLeft: 250 }}>{guardiansName}</CustomTypography>
        <CustomTypography style={{ marginLeft: 250 }}>{guardiansNumber}</CustomTypography>
      </Stack>
      <HeightBox height={80} />
      <Stack direction="row">
        <div style={{ marginLeft: 140, width: 160 }}>
          <CustomTypography>{experienceOneCountry ? experienceOneCountry : "-"}</CustomTypography>
        </div>
        <div style={{ width: 240 }}>
          <CustomTypography>{experienceOneCountry ? experienceOneServicePeriod : "-"}</CustomTypography>
        </div>
        <div style={{ width: 200 }}>
          <CustomTypography>{experienceOneCountry ? experienceOneJob : "-"}</CustomTypography>
        </div>
      </Stack>
      <HeightBox height={6} />
      <Stack direction="row">
        <div style={{ marginLeft: 140, width: 160 }}>
          <CustomTypography>{experienceTwoCountry ? experienceTwoCountry : "-"}</CustomTypography>
        </div>
        <div style={{ width: 240 }}>
          <CustomTypography>{experienceTwoCountry ? experienceTwoServicePeriod : "-"}</CustomTypography>
        </div>
        <div style={{ width: 200 }}>
          <CustomTypography>{experienceTwoCountry ? experienceTwoJob : "-"}</CustomTypography>
        </div>
      </Stack>
      <HeightBox height={1} />
      <Stack direction="row">
        <div style={{ marginLeft: 140, width: 160 }}>
          <CustomTypography>{experienceThreeCountry ? experienceThreeCountry : "-"}</CustomTypography>
        </div>
        <div>
          <CustomTypography>{experienceThreeCountry ? experienceThreeServicePeriod : "-"}</CustomTypography>
        </div>
        <div style={{ width: 200 }}>
          <CustomTypography>{experienceThreeCountry ? experienceThreeJob : "-"}</CustomTypography>
        </div>
      </Stack>
      <HeightBox height={28} />
      <Stack direction="row">
        <CustomTypography fontWeight={800} style={{ marginLeft: 250 }}>
          {english ? "x" : "-"}
        </CustomTypography>
        <CustomTypography fontWeight={800} style={{ marginLeft: 73 }}>
          {arabic ? "x" : "-"}
        </CustomTypography>
        <CustomTypography fontWeight={800} style={{ marginLeft: 92 }}>
          {hindi ? "x" : "-"}
        </CustomTypography>
        <CustomTypography fontWeight={800} style={{ marginLeft: 83 }}>
          {tamil ? "x" : "-"}
        </CustomTypography>
        <CustomTypography fontWeight={800} style={{ marginLeft: 97 }}>
          {other ? "x" : "-"}
        </CustomTypography>
      </Stack>
      <HeightBox height={10} />
      <CustomTypography style={{ marginLeft: 400 }}>{destinationCountry}</CustomTypography>
      <HeightBox height={45} />
      <CustomTypography style={{ marginLeft: 100 }}>{fullName}</CustomTypography>
      <HeightBox height={60} /> */}
    </Container>
  );
});
